import { FC } from 'react';
import { TagTypeWithColor, tag_types } from './tag_type';

interface IProps {
	on_select_tag_type: (tag: TagTypeWithColor) => void;
	disabled?: boolean;
}

export const SelectTagType: FC<IProps> = ({ on_select_tag_type, disabled }) => {
	return (
		<>
			<h2 className='text-sm pb-1'>Escolha o tipo desejado</h2>

			<ul className='flex flex-row mb-1'>
				{tag_types.map((tag_type) => {
					const isIa = tag_type.value === 'ia';
					const isBlocked = disabled && !isIa;
					if (disabled && tag_type.value === 'video') {
						return null;
					}
					return (
						<li
							key={tag_type.value}
							className={`
								my-1 mx-0.5 py-1 px-2 rounded text-white
								${tag_type.color}
								${isBlocked ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer hover:bg-opacity-70'}
							`}
							onClick={() => {
								if (isBlocked) return;
								on_select_tag_type(tag_type);
							}}
						>
							{tag_type.title}
						</li>
					);
				})}
			</ul>
		</>
	);
};
